import { c as cn } from './chunks/index-9d6795ea.js';
import React__default from 'react';
import { Button, Typography } from '@sravni/react-design-system';

var modules_2208352c = {"wrapper":"_31orqc","wrapper--visibleDescription":"_14yq407","link":"_k8g9o0","btn":"_7ttlbg"};
import "./assets/CallToActionSideBlock.css";

var CallToActionSideBlock$1 = function (_a) {
    var _b;
    var title = _a.title, text = _a.text, description = _a.description, buttonLabel = _a.buttonLabel, link = _a.link, handleClick = _a.handleClick, _c = _a.linkTarget, linkTarget = _c === void 0 ? '_self' : _c, _d = _a.isOnlyButton, isOnlyButton = _d === void 0 ? false : _d, _e = _a.isVisibleDescription, isVisibleDescription = _e === void 0 ? false : _e, _f = _a.isMobile, isMobile = _f === void 0 ? false : _f;
    var button = (React__default.createElement("a", { onClick: handleClick, className: modules_2208352c.link, href: link, target: linkTarget },
        React__default.createElement(Button, { className: modules_2208352c.btn, color: "gray", size: 52, variant: "primary", block: true }, buttonLabel)));
    if (isOnlyButton)
        return button;
    return isMobile ? (React__default.createElement("div", { className: modules_2208352c.wrapper },
        button,
        React__default.createElement(Typography.Text, { size: 14, className: "h-mt-16" }, text))) : (React__default.createElement("div", { className: cn(modules_2208352c.wrapper, (_b = {},
            _b[modules_2208352c['wrapper--visibleDescription']] = isVisibleDescription,
            _b)) },
        React__default.createElement(Typography.Heading, { level: 3 }, title),
        React__default.createElement(Typography.Text, { size: 14, className: "h-mt-8 h-mb-24" }, text),
        button,
        isVisibleDescription && React__default.createElement("div", { className: "h-mt-24" }, description)));
};

export { CallToActionSideBlock$1 as CallToActionSideBlock };
